import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import TitleH4Component from "../../components/TitleH4Component";
import ParrafoComponent from "../../components/ParrafoComponent";
import InputComponent from "../../components/InputComponent";
import MoneyInputComponent from "../../components/MoneyInputComponent";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import AlertComponent from "../../components/AlertComponent";
import LoaderComponent from "../../components/LoaderComponent";
import EstadoAlquilerComponent from "../../components/EstadoAlquilerComponent";
import { Icon } from "@iconify/react/dist/iconify.js";
import stylebtn from "../../styles/btn.module.scss";
import stylegeneral from "../../styles/general.module.scss";
import { useAuth } from "../../context/AuthContext";
import { useFormatter } from "../../hooks/useFormatter";
import {
  getUnAlquiler,
  registrarDevolucionAlquiler,
  editarCantidadAlquilerDetalle,
  eliminarDevolucion,
  aplicarAbonoAlquiler,
  postAbonoAlquiler,
  editarAbonoAlquiler,
  eliminarAbonoAlquiler,
} from "../../api/Alquiler";
import { abrirPdfAlquiler } from "../../api/Pdf";
import BotonWhatsappPdfComponent from "../../components/BotonWhatsappPdfComponent";
import { compartirAlquilerWhatsApp } from "../../helpers/compartirDocumentoWhatsApp";

const DetalleAlquilerPage = () => {
  const { id } = useParams();
  const { idUser, isAdmin } = useAuth();
  const { formatDateHora, formatPrice, getNowDateTimeInput, formatDate, formatDateInput, formtTodayBogota } =
    useFormatter();

  const [loading, setLoading] = useState(false);
  const [alquiler, setAlquiler] = useState(null);
  const [errorCarga, setErrorCarga] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [alert, setAlert] = useState(false);
  const [mensajealerta, setMensajealerta] = useState("");

  const [showDevolucion, setShowDevolucion] = useState(false);
  const [detalleActual, setDetalleActual] = useState(null);
  const [formDevolucion, setFormDevolucion] = useState({
    cantidadDevuelta: "",
    fecha_hora_devolucion: "",
    cantidadDanada: "",
    precioDano: "",
  });
  // Monto que se paga en el mismo momento de la devolución (total o
  // parcial): se registra como un abono aparte, ver confirmarDevolucion.
  const [montoPago, setMontoPago] = useState("");

  // ── Corrección de cantidad (solo admin) ──
  const [showEditarCantidad, setShowEditarCantidad] = useState(false);
  const [detalleEditar, setDetalleEditar] = useState(null);
  const [nuevaCantidad, setNuevaCantidad] = useState("");
  const [mensajeEditar, setMensajeEditar] = useState("");

  // ── Eliminar un registro del historial (solo admin) ──
  const [showEliminarDevolucion, setShowEliminarDevolucion] = useState(false);
  const [devolucionAEliminar, setDevolucionAEliminar] = useState(null);

  // ── Registrar abono ──
  const [showRegistrarAbono, setShowRegistrarAbono] = useState(false);
  const [formAbono, setFormAbono] = useState({
    monto: "",
    descripcion: "",
    fecha_abono: "",
    hora_abono: "",
  });
  const [mensajeAbono, setMensajeAbono] = useState("");

  // ── Listado / edición / eliminación de abonos ──
  const [showAbonos, setShowAbonos] = useState(false);
  const [showEditarAbono, setShowEditarAbono] = useState(false);
  const [abonoEditar, setAbonoEditar] = useState(null);
  const [formEditarAbono, setFormEditarAbono] = useState({
    monto: "",
    descripcion: "",
    fecha_abono: "",
    hora_abono: "",
  });
  const [mensajeEditarAbono, setMensajeEditarAbono] = useState("");
  const [showEliminarAbono, setShowEliminarAbono] = useState(false);
  const [abonoAEliminar, setAbonoAEliminar] = useState(null);
  // Id del abono cuya descripción está expandida (clic en la celda) en el
  // modal de listado; null = ninguna expandida (todas truncadas con "...").
  const [descripcionAbonoExpandida, setDescripcionAbonoExpandida] = useState(null);

  // Nombre a mostrar: si la línea está ligada al catálogo usa los datos del
  // Producto; si es manual (sin idProducto), usa el nombre digitado.
  const nombreProducto = (detalle) =>
    detalle?.Producto
      ? `${detalle.Producto.Clase?.name || ""} ${detalle.Producto.Tipo?.name || ""} ${detalle.Producto.dimension || ""}`
      : detalle?.producto || "";

  const fetchAlquiler = async () => {
    setLoading(true);
    try {
      const { status, res } = await getUnAlquiler(id);
      if (status === 200) {
        setAlquiler(res?.data);
        setErrorCarga("");
      } else {
        setErrorCarga(res?.msg || "No fue posible cargar el alquiler");
      }
    } catch (error) {
      console.error(error);
      setErrorCarga("No fue posible conectar con el servidor");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchAlquiler();
  }, [id]);

  const nombreCliente =
    alquiler?.nombre ||
    `${alquiler?.Cliente?.Persona?.nombre || ""} ${alquiler?.Cliente?.Persona?.apellido || ""}`;

  const handleShowDevolucion = (detalle) => {
    setDetalleActual(detalle);
    setFormDevolucion({
      cantidadDevuelta: detalle.cantidad - detalle.cantidadDevuelta,
      fecha_hora_devolucion: getNowDateTimeInput(),
      cantidadDanada: "",
      precioDano: "",
    });
    setMontoPago("");
    setShowDevolucion(true);
  };

  const handleCloseDevolucion = () => {
    setShowDevolucion(false);
    setDetalleActual(null);
    setMontoPago("");
    setMensaje("");
  };

  const handleChangeDevolucion = (e) => {
    const { name, value } = e.target;
    setFormDevolucion((prev) => ({ ...prev, [name]: value }));
  };

  // Estimado en vivo de lo que cuesta ESTA devolución (días reales los
  // recalcula siempre el backend al confirmar; esto es solo referencia para
  // que el vendedor sepa cuánto cobrar en el momento).
  const diasEstimadosDevolucion =
    detalleActual && formDevolucion.fecha_hora_devolucion && alquiler?.fecha_hora_salida
      ? Math.max(
          1,
          Math.ceil(
            (new Date(formDevolucion.fecha_hora_devolucion) - new Date(alquiler.fecha_hora_salida)) /
              (24 * 60 * 60 * 1000),
          ),
        )
      : 0;
  const subtotalEstimadoDevolucion = detalleActual
    ? Number(formDevolucion.cantidadDevuelta || 0) *
      Number(detalleActual.precioDiario || 0) *
      diasEstimadosDevolucion
    : 0;

  const confirmarDevolucion = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { status, res } = await registrarDevolucionAlquiler(detalleActual.id, {
        cantidadDevuelta: Number(formDevolucion.cantidadDevuelta),
        fecha_hora_devolucion: formDevolucion.fecha_hora_devolucion,
        id_user: idUser,
        cantidadDanada: formDevolucion.cantidadDanada || 0,
        precioDano: formDevolucion.precioDano || 0,
      });

      if (status === 200 && res?.success) {
        // Pago inmediato (total o parcial) de esta devolución: primero se
        // aplica al total_pagado (valida contra la deuda) y luego se deja
        // el registro de auditoría, igual que en venta rápida (obtenerAbonos
        // -> postAbonoVR).
        let mensajeFinal = res.msg;
        if (Number(montoPago) > 0) {
          const resAbono = await aplicarAbonoAlquiler(alquiler.id, Number(montoPago));
          if (resAbono.status === 200 && resAbono.res?.success) {
            await postAbonoAlquiler(
              alquiler.id,
              Number(montoPago),
              `Pago por devolución de ${nombreProducto(detalleActual)}`,
              idUser,
              formtTodayBogota(),
              new Date().toTimeString().slice(0, 8),
            );
          } else {
            mensajeFinal =
              resAbono.res?.msg || "La devolución se registró, pero no fue posible aplicar el pago";
          }
        }

        handleCloseDevolucion();
        setAlert(true);
        setMensajealerta(mensajeFinal);
        fetchAlquiler();
      } else {
        setMensaje(res?.msg || "No fue posible registrar la devolución");
      }
    } catch (error) {
      setMensaje("No fue posible registrar la devolución");
    } finally {
      setLoading(false);
      setTimeout(() => setAlert(false), 4000);
    }
  };

  const handleShowEditarCantidad = (detalle) => {
    setDetalleEditar(detalle);
    setNuevaCantidad(detalle.cantidad);
    setMensajeEditar("");
    setShowEditarCantidad(true);
  };

  const handleCloseEditarCantidad = () => {
    setShowEditarCantidad(false);
    setDetalleEditar(null);
    setMensajeEditar("");
  };

  const confirmarEditarCantidad = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { status, res } = await editarCantidadAlquilerDetalle(
        detalleEditar.id,
        Number(nuevaCantidad),
      );

      if (status === 200 && res?.success) {
        handleCloseEditarCantidad();
        setAlert(true);
        setMensajealerta(res.msg);
        fetchAlquiler();
      } else {
        setMensajeEditar(res?.msg || "No fue posible corregir la cantidad");
      }
    } catch (error) {
      setMensajeEditar("No fue posible corregir la cantidad");
    } finally {
      setLoading(false);
      setTimeout(() => setAlert(false), 4000);
    }
  };

  const handleShowEliminarDevolucion = (dev) => {
    setDevolucionAEliminar(dev);
    setShowEliminarDevolucion(true);
  };

  const handleCloseEliminarDevolucion = () => {
    setShowEliminarDevolucion(false);
    setDevolucionAEliminar(null);
  };

  const confirmarEliminarDevolucion = async () => {
    try {
      setLoading(true);
      const { status, res } = await eliminarDevolucion(devolucionAEliminar.id);

      if (status === 200 && res?.success) {
        setAlert(true);
        setMensajealerta(res.msg);
        fetchAlquiler();
      } else {
        setMensajealerta(res?.msg || "No fue posible eliminar la devolución");
        setAlert(true);
      }
    } catch (error) {
      setMensajealerta("No fue posible eliminar la devolución");
      setAlert(true);
    } finally {
      handleCloseEliminarDevolucion();
      setLoading(false);
      setTimeout(() => setAlert(false), 4000);
    }
  };

  // ── Registrar abono ──
  const handleShowRegistrarAbono = () => {
    setFormAbono({
      monto: "",
      descripcion: "",
      fecha_abono: formtTodayBogota(),
      hora_abono: new Date().toTimeString().slice(0, 5),
    });
    setMensajeAbono("");
    setShowRegistrarAbono(true);
  };

  const handleCloseRegistrarAbono = () => {
    setShowRegistrarAbono(false);
    setMensajeAbono("");
  };

  const handleChangeAbono = (e) => {
    const { name, value } = e.target;
    setFormAbono((prev) => ({ ...prev, [name]: value }));
  };

  const confirmarRegistrarAbono = async (e) => {
    e.preventDefault();
    if (!formAbono.monto || Number(formAbono.monto) <= 0) {
      setMensajeAbono("El monto del abono debe ser mayor a 0");
      return;
    }
    try {
      setLoading(true);
      // Primero se aplica el pago al total_pagado (valida contra la deuda
      // pendiente) y luego se deja el registro de auditoría, igual que en
      // venta rápida (obtenerAbonos -> postAbonoVR).
      const resAplicar = await aplicarAbonoAlquiler(alquiler.id, Number(formAbono.monto));
      if (resAplicar.status !== 200 || !resAplicar.res?.success) {
        setMensajeAbono(resAplicar.res?.msg || "No fue posible registrar el abono");
        return;
      }

      const { status, res } = await postAbonoAlquiler(
        alquiler.id,
        Number(formAbono.monto),
        formAbono.descripcion,
        idUser,
        formAbono.fecha_abono || null,
        formAbono.hora_abono || null,
      );

      if (status === 201 && res?.success) {
        handleCloseRegistrarAbono();
        setAlert(true);
        setMensajealerta("Abono registrado correctamente");
        fetchAlquiler();
      } else {
        setMensajeAbono(res?.msg || "No fue posible registrar el abono");
      }
    } catch (error) {
      setMensajeAbono("No fue posible registrar el abono");
    } finally {
      setLoading(false);
      setTimeout(() => setAlert(false), 4000);
    }
  };

  // ── Listado / edición / eliminación de abonos ──
  const abonos = alquiler?.AbonoAlquilers || [];

  const handleShowEditarAbono = (abono) => {
    setAbonoEditar(abono);
    setFormEditarAbono({
      monto: abono.monto,
      descripcion: abono.descripcion || "",
      fecha_abono: abono.fecha_abono ? formatDateInput(abono.fecha_abono) : "",
      hora_abono: abono.hora_abono ? abono.hora_abono.slice(0, 5) : "",
    });
    setMensajeEditarAbono("");
    setShowEditarAbono(true);
  };

  const handleCloseEditarAbono = () => {
    setShowEditarAbono(false);
    setAbonoEditar(null);
    setMensajeEditarAbono("");
  };

  const handleChangeEditarAbono = (e) => {
    const { name, value } = e.target;
    setFormEditarAbono((prev) => ({ ...prev, [name]: value }));
  };

  const confirmarEditarAbono = async (e) => {
    e.preventDefault();
    if (!formEditarAbono.monto || Number(formEditarAbono.monto) <= 0) {
      setMensajeEditarAbono("El monto del abono debe ser mayor a 0");
      return;
    }
    try {
      setLoading(true);
      const { status, res } = await editarAbonoAlquiler(abonoEditar.id, {
        monto: Number(formEditarAbono.monto),
        descripcion: formEditarAbono.descripcion,
        fecha_abono: formEditarAbono.fecha_abono || null,
        hora_abono: formEditarAbono.hora_abono || null,
      });

      if (status === 200 && res?.success) {
        handleCloseEditarAbono();
        setAlert(true);
        setMensajealerta("Abono actualizado correctamente");
        fetchAlquiler();
      } else {
        setMensajeEditarAbono(res?.msg || "No fue posible actualizar el abono");
      }
    } catch (error) {
      setMensajeEditarAbono("No fue posible actualizar el abono");
    } finally {
      setLoading(false);
      setTimeout(() => setAlert(false), 4000);
    }
  };

  const handleShowEliminarAbono = (abono) => {
    setAbonoAEliminar(abono);
    setShowEliminarAbono(true);
  };

  const handleCloseEliminarAbono = () => {
    setShowEliminarAbono(false);
    setAbonoAEliminar(null);
  };

  const confirmarEliminarAbono = async () => {
    try {
      setLoading(true);
      const { status, res } = await eliminarAbonoAlquiler(abonoAEliminar.id);

      if (status === 200 && res?.success) {
        setAlert(true);
        setMensajealerta(res.msg);
        fetchAlquiler();
      } else {
        setMensajealerta(res?.msg || "No fue posible eliminar el abono");
        setAlert(true);
      }
    } catch (error) {
      setMensajealerta("No fue posible eliminar el abono");
      setAlert(true);
    } finally {
      handleCloseEliminarAbono();
      setLoading(false);
      setTimeout(() => setAlert(false), 4000);
    }
  };

  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <AlertComponent
          styleGroup="bg-soccess color-white"
          mensaje={mensajealerta}
          activaalert={alert}
        />
      </div>
      <HeaderComponent>
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          DETALLE DE ALQUILER
        </TitleH2Component>
      </HeaderComponent>

      <div className="conatiner-global pt-3 mb-5">
        {loading && !alquiler ? (
          <LoaderComponent styleGroup="mt-5" />
        ) : !alquiler ? (
          <>
            <TitleH2Component styleGroup="box-text color-dark fw700 roboto mt-5 text-center WorkSans">
              ALQUILER NO ENCONTRADO
            </TitleH2Component>
            {errorCarga && (
              <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mt-2">
                {errorCarga}
              </ParrafoComponent>
            )}
          </>
        ) : (
          <>
            <div className="container d-flex flex-wrap justify-content-end gap-2 mb-3">
              <button
                type="button"
                className={`${stylebtn.btn} ${stylebtn.primary}`}
                onClick={() => abrirPdfAlquiler(alquiler.id)}
              >
                Imprimir comprobante
              </button>
              <BotonWhatsappPdfComponent onClick={() => compartirAlquilerWhatsApp(alquiler)} />
            </div>

            <section className="container border border-dark rounded p-3 mb-4">
              <div className="row gy-3">
                <div className="col-12 col-md-6 col-xl-3">
                  <TitleH4Component styleGroup="box-text color-dark fw700 roboto mb-1">
                    {nombreCliente}
                  </TitleH4Component>
                  <ParrafoComponent styleGroup="box-text color-dark fw700 roboto mb-1">
                    CC: {alquiler?.cedula || alquiler?.Cliente?.Persona?.cedula}
                  </ParrafoComponent>
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <ParrafoComponent styleGroup="box-text fw700 roboto mb-1">
                    Salida: {formatDateHora(alquiler?.fecha_hora_salida)}
                  </ParrafoComponent>
                  {alquiler?.fecha_hora_devolucion_esperada && (
                    <ParrafoComponent styleGroup="box-text fw700 roboto mb-1">
                      Devolución esperada:{" "}
                      {formatDateHora(alquiler?.fecha_hora_devolucion_esperada)}
                    </ParrafoComponent>
                  )}
                  {alquiler?.fecha_hora_devolucion && (
                    <ParrafoComponent styleGroup="box-text fw700 roboto mb-1">
                      Devolución completa:{" "}
                      {formatDateHora(alquiler?.fecha_hora_devolucion)}
                    </ParrafoComponent>
                  )}
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <EstadoAlquilerComponent
                    as="div"
                    estado={alquiler?.estado}
                    fechaHoraDevolucionEsperada={alquiler?.fecha_hora_devolucion_esperada}
                    styleGroup="fw700 roboto py-2 rounded"
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <ParrafoComponent styleGroup="box-text fw700 roboto mb-1">
                    Vendedor: {alquiler?.User?.nombre || alquiler?.vendedor}
                  </ParrafoComponent>
                  <ParrafoComponent styleGroup="box-text fw700 roboto mb-1">
                    Total: <span className="color-soccess">{formatPrice(alquiler?.total)}</span>
                  </ParrafoComponent>
                </div>
                {(alquiler?.quien_recibe || alquiler?.direccion_recibe) && (
                  <div className="col-12 col-md-6">
                    {alquiler?.quien_recibe && (
                      <ParrafoComponent styleGroup="box-text fw400 roboto mb-1">
                        Quien recibe: {alquiler.quien_recibe}
                      </ParrafoComponent>
                    )}
                    {alquiler?.direccion_recibe && (
                      <ParrafoComponent styleGroup="box-text fw400 roboto mb-1">
                        Dirección de entrega: {alquiler.direccion_recibe}
                      </ParrafoComponent>
                    )}
                  </div>
                )}
                {alquiler?.observaciones && (
                  <div className="col-12">
                    <ParrafoComponent styleGroup="box-text fw400 roboto mb-0">
                      Observaciones: {alquiler?.observaciones}
                    </ParrafoComponent>
                  </div>
                )}
              </div>
            </section>

            <section className="container border border-dark rounded p-3 mb-4">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <TitleH4Component styleGroup="box-text color-madera fw700 roboto mb-0">
                  TRANSPORTE, ABONO Y DESCUENTO
                </TitleH4Component>
                <button
                  type="button"
                  className={`${stylebtn.btn} ${stylebtn.primary}`}
                  onClick={handleShowRegistrarAbono}
                >
                  Registrar abono
                </button>
              </div>
              <div className="row gy-2">
                {Number(alquiler?.transporte) > 0 && (
                  <div className="col-12 col-md-6 col-xl-3">
                    <ParrafoComponent styleGroup="box-text fw700 roboto mb-1">
                      Transporte: {formatPrice(alquiler?.transporte)}
                    </ParrafoComponent>
                    {alquiler?.nombre_conductor && (
                      <ParrafoComponent styleGroup="box-text fw400 roboto mb-1">
                        Conductor: {alquiler.nombre_conductor}
                        {alquiler?.celular_conductor ? ` - ${alquiler.celular_conductor}` : ""}
                      </ParrafoComponent>
                    )}
                  </div>
                )}
                {Number(alquiler?.descuento) > 0 && (
                  <div className="col-12 col-md-6 col-xl-3">
                    <ParrafoComponent styleGroup="box-text fw700 roboto mb-1">
                      Descuento: {formatPrice(alquiler?.descuento)}
                    </ParrafoComponent>
                  </div>
                )}
                <div className="col-12 col-md-6 col-xl-3">
                  <ParrafoComponent styleGroup="box-text fw700 roboto mb-1">
                    Abonado: <span className="color-soccess">{formatPrice(alquiler?.total_pagado)}</span>
                  </ParrafoComponent>
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <ParrafoComponent styleGroup="box-text fw700 roboto mb-1">
                    Pendiente por pagar:{" "}
                    <span className="color-danger">
                      {formatPrice(
                        Math.max(
                          0,
                          Number(alquiler?.total || 0) +
                            Number(alquiler?.transporte || 0) -
                            Number(alquiler?.descuento || 0) -
                            Number(alquiler?.total_pagado || 0),
                        ),
                      )}
                    </span>
                  </ParrafoComponent>
                </div>
                {alquiler?.descripcionPago && (
                  <div className="col-12">
                    <ParrafoComponent styleGroup="box-text fw400 roboto mb-0">
                      Descripción de pago: {alquiler.descripcionPago}
                    </ParrafoComponent>
                  </div>
                )}
                <div className="col-12 d-flex justify-content-center">
                  <button
                    type="button"
                    className={stylebtn.btn_abonos}
                    onClick={() => setShowAbonos(true)}
                  >
                    <Icon icon="solar:wallet-money-bold" />
                    Abonos registrados: {abonos.length}
                  </button>
                </div>
              </div>
            </section>

            <section className="container mb-4">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-3">
                PRODUCTOS ALQUILADOS
              </TitleH4Component>
              <div className="table-responsive">
                <table className="table table-bordered tableGeneral">
                  <thead>
                    <tr>
                      <th className="color-madera">Producto</th>
                      <th className="color-madera text-center">Cantidad</th>
                      <th className="color-madera text-center">Devuelto</th>
                      <th className="color-madera text-center">Pendiente</th>
                      <th className="color-madera text-end">Precio/día</th>
                      <th className="color-madera text-end">Valor/día</th>
                      <th className="color-madera text-end">Subtotal</th>
                      <th className="color-madera text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(alquiler?.AlquilerDetalles || []).map((detalle) => {
                      const pendiente = detalle.cantidad - detalle.cantidadDevuelta;
                      return (
                        <tr key={detalle.id}>
                          <td>{nombreProducto(detalle)}</td>
                          <td className="text-center">{detalle.cantidad}</td>
                          <td className="text-center">{detalle.cantidadDevuelta}</td>
                          <td className="text-center">{pendiente}</td>
                          <td className="text-end">{formatPrice(detalle.precioDiario)}</td>
                          <td className="text-end">
                            {formatPrice(detalle.cantidad * detalle.precioDiario)}
                          </td>
                          <td className="text-end">{formatPrice(detalle.subtotal)}</td>
                          <td className="text-center">
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <button
                                type="button"
                                className={`${stylebtn.btn} ${stylebtn.primary}`}
                                disabled={pendiente <= 0 || alquiler?.estado === "devuelto"}
                                onClick={() => handleShowDevolucion(detalle)}
                              >
                                Devolver
                              </button>
                              {isAdmin && (
                                <button
                                  type="button"
                                  className={`${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex`}
                                  title="Corregir cantidad"
                                  onClick={() => handleShowEditarCantidad(detalle)}
                                >
                                  <Icon icon="raphael:edit" />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </section>

            <section className="container mb-4">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-3">
                HISTORIAL DE DEVOLUCIONES
              </TitleH4Component>
              <div className="table-responsive">
                <table className="table table-bordered tableGeneral">
                  <thead>
                    <tr>
                      <th className="color-madera">Producto</th>
                      <th className="color-madera text-center">Cantidad</th>
                      <th className="color-madera text-center">Fecha/hora</th>
                      <th className="color-madera text-center">Días</th>
                      <th className="color-madera text-end">Subtotal</th>
                      <th className="color-madera text-center">Dañado</th>
                      <th className="color-madera text-end">Multa daño</th>
                      <th className="color-madera">Registrado por</th>
                      {isAdmin && (
                        <th className="color-madera text-center">Acción</th>
                      )}
                    </tr>
                  </thead>
                  {(alquiler?.AlquilerDetalles || []).flatMap(
                    (detalle) => detalle.DevolucionAlquilers || [],
                  ).length > 0 ? (
                    <tbody>
                      {(alquiler?.AlquilerDetalles || []).flatMap((detalle) =>
                        (detalle.DevolucionAlquilers || []).map((dev) => (
                          <tr key={dev.id}>
                            <td>{nombreProducto(detalle)}</td>
                            <td className="text-center">{dev.cantidadDevuelta}</td>
                            <td className="text-center">
                              {formatDateHora(dev.fecha_hora_devolucion)}
                            </td>
                            <td className="text-center">{dev.diasAlquiler}</td>
                            <td className="text-end">{formatPrice(dev.subtotal)}</td>
                            <td className="text-center">
                              {dev.cantidadDanada > 0 ? dev.cantidadDanada : "-"}
                            </td>
                            <td className="text-end">
                              {dev.multaDano > 0 ? formatPrice(dev.multaDano) : "-"}
                            </td>
                            <td>{dev.User?.nombre || "-"}</td>
                            {isAdmin && (
                              <td className="text-center">
                                <button
                                  type="button"
                                  className={`${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex color-danger`}
                                  title="Eliminar devolución"
                                  onClick={() => handleShowEliminarDevolucion(dev)}
                                >
                                  <Icon icon="majesticons:delete-bin" />
                                </button>
                              </td>
                            )}
                          </tr>
                        )),
                      )}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={isAdmin ? 9 : 8} className="text-center">
                          AÚN NO HAY DEVOLUCIONES REGISTRADAS
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </section>
          </>
        )}
      </div>

      <ModalGeneralComponent
        ModalHeader
        titulo="Registrar devolución"
        styleGroup="d-flex align-items-center modal-general"
        styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
        show={showDevolucion}
        handleClose={handleCloseDevolucion}
      >
        <form onSubmit={confirmarDevolucion}>
          <ParrafoComponent styleGroup="box-text color-dark fw700 roboto mb-3 text-center">
            {nombreProducto(detalleActual)}
          </ParrafoComponent>

          <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">
            {mensaje}
          </ParrafoComponent>

          <div className="row mb-4 gap-3 gap-md-0">
            <div className="col-12 col-md-6">
              <InputComponent
                label={`Cantidad a devolver`}
                styleLabel="fw600 WorkSans"
                type="number"
                name="cantidadDevuelta"
                value={formDevolucion.cantidadDevuelta}
                onChange={handleChangeDevolucion}
              />
            </div>
            <div className="col-12 col-md-6">
              <InputComponent
                label="Fecha y hora de devolución"
                styleLabel="fw600 WorkSans"
                type="datetime-local"
                name="fecha_hora_devolucion"
                value={formDevolucion.fecha_hora_devolucion}
                onChange={handleChangeDevolucion}
              />
            </div>
          </div>

          <ParrafoComponent styleGroup="box-text color-madera fw700 roboto my-4">
            ¿Llegó algo dañado o deteriorado? (opcional)
          </ParrafoComponent>
          <div className="row mb-3 gap-3 gap-md-0">
            <div className="col-12 col-md-6">
              <InputComponent
                label={`Cantidad dañada`}
                styleLabel="fw600 WorkSans"
                type="number"
                name="cantidadDanada"
                value={formDevolucion.cantidadDanada}
                onChange={handleChangeDevolucion}
              />
            </div>
            <div className="col-12 col-md-6">
              <MoneyInputComponent
                label="Multa por unidad dañada"
                styleLabel="fw600 WorkSans"
                name="precioDano"
                value={formDevolucion.precioDano}
                onChange={handleChangeDevolucion}
              />
            </div>
          </div>
          {Number(formDevolucion.cantidadDanada) > 0 && Number(formDevolucion.precioDano) > 0 && (
            <ParrafoComponent styleGroup="text-end color-danger fw700 WorkSans mb-3">
              Multa por daño:{" "}
              {formatPrice(
                Number(formDevolucion.cantidadDanada) * Number(formDevolucion.precioDano),
              )}
            </ParrafoComponent>
          )}

          <ParrafoComponent styleGroup="box-text color-madera fw700 roboto my-4">
            ¿Cobra en este momento?
          </ParrafoComponent>
          <ParrafoComponent styleGroup="box-text color-gris fw400 WorkSans mb-2">
            Valor estimado de esta devolución:{" "}
            <span className="color-soccess">{formatPrice(subtotalEstimadoDevolucion)}</span> (el
            total exacto lo calcula el sistema con los días reales).
          </ParrafoComponent>
          <div className="row mb-3 gap-3 gap-md-0 align-items-end">
            <div className="col-12 col-md-6">
              <MoneyInputComponent
                label="Monto a pagar ahora"
                styleLabel="fw600 WorkSans"
                name="montoPago"
                value={montoPago}
                onChange={(e) => setMontoPago(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6">
              <button
                type="button"
                className={`${stylebtn.btn} ${stylebtn.secundary}`}
                onClick={() => setMontoPago(subtotalEstimadoDevolucion)}
              >
                Pagar completo
              </button>
            </div>
          </div>

          <div className="d-flex w-100 justify-content-end">
            <button
              type="button"
              className={`${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3`}
              onClick={handleCloseDevolucion}
            >
              CANCELAR
            </button>
            <button
              type="submit"
              className={`btn ${stylebtn.btn} ${stylebtn.primary}`}
            >
              CONFIRMAR
            </button>
          </div>
        </form>
      </ModalGeneralComponent>

      <ModalGeneralComponent
        ModalHeader
        titulo="Corregir cantidad"
        styleGroup="d-flex align-items-center modal-general"
        styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
        show={showEditarCantidad}
        handleClose={handleCloseEditarCantidad}
      >
        <form onSubmit={confirmarEditarCantidad}>
          <ParrafoComponent styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
            {nombreProducto(detalleEditar)}
          </ParrafoComponent>
          <ParrafoComponent styleGroup="box-text color-gris fw400 WorkSans mb-3 text-center">
            Ya devuelto: {detalleEditar?.cantidadDevuelta ?? 0} unidades — no puede corregir por
            debajo de esa cifra.
          </ParrafoComponent>

          <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">
            {mensajeEditar}
          </ParrafoComponent>

          <div className="row mb-4">
            <div className="col-12">
              <InputComponent
                label="Cantidad correcta"
                styleLabel="fw600 WorkSans"
                type="number"
                name="nuevaCantidad"
                value={nuevaCantidad}
                onChange={(e) => setNuevaCantidad(e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex w-100 justify-content-end">
            <button
              type="button"
              className={`${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3`}
              onClick={handleCloseEditarCantidad}
            >
              CANCELAR
            </button>
            <button
              type="submit"
              className={`btn ${stylebtn.btn} ${stylebtn.primary}`}
            >
              GUARDAR
            </button>
          </div>
        </form>
      </ModalGeneralComponent>

      <ModalGeneralComponent
        styleGroup="d-flex align-items-center modal-general"
        styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
        show={showEliminarDevolucion}
        handleClose={handleCloseEliminarDevolucion}
      >
        <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-2 text-center">
          ¿Seguro que quiere eliminar esta devolución?
        </TitleH2Component>
        <ParrafoComponent styleGroup="box-text color-gris fw400 WorkSans mb-4 text-center">
          Esto revierte la cantidad, el subtotal, la multa por daño (si tenía) y
          vuelve a descontar del inventario las unidades como si no se hubieran
          devuelto.
        </ParrafoComponent>
        <div className="d-flex justify-content-end">
          <button
            type="button"
            onClick={handleCloseEliminarDevolucion}
            className={`btn ${stylebtn.btn} ${stylebtn.danger}`}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
            onClick={confirmarEliminarDevolucion}
          >
            SI
          </button>
        </div>
      </ModalGeneralComponent>

      <ModalGeneralComponent
        ModalHeader
        titulo="Registrar abono"
        styleGroup="d-flex align-items-center modal-general"
        styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
        show={showRegistrarAbono}
        handleClose={handleCloseRegistrarAbono}
      >
        <form onSubmit={confirmarRegistrarAbono}>
          <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">
            {mensajeAbono}
          </ParrafoComponent>

          <div className="row mb-3 gap-3 gap-md-0">
            <div className="col-12 col-md-6">
              <MoneyInputComponent
                label="Monto del abono"
                styleLabel="fw600 WorkSans"
                name="monto"
                value={formAbono.monto}
                onChange={handleChangeAbono}
              />
            </div>
            <div className="col-12 col-md-3">
              <InputComponent
                label="Fecha"
                styleLabel="fw600 WorkSans"
                type="date"
                name="fecha_abono"
                value={formAbono.fecha_abono}
                onChange={handleChangeAbono}
              />
            </div>
            <div className="col-12 col-md-3">
              <InputComponent
                label="Hora"
                styleLabel="fw600 WorkSans"
                type="time"
                name="hora_abono"
                value={formAbono.hora_abono}
                onChange={handleChangeAbono}
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-12">
              <textarea
                name="descripcion"
                placeholder="Descripción del abono"
                className="form-control"
                rows={3}
                value={formAbono.descripcion}
                onChange={handleChangeAbono}
              ></textarea>
            </div>
          </div>

          <div className="d-flex w-100 justify-content-end">
            <button
              type="button"
              className={`${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3`}
              onClick={handleCloseRegistrarAbono}
            >
              CANCELAR
            </button>
            <button type="submit" className={`btn ${stylebtn.btn} ${stylebtn.primary}`}>
              REGISTRAR
            </button>
          </div>
        </form>
      </ModalGeneralComponent>

      <ModalGeneralComponent
        ModalHeader
        titulo="ABONOS REGISTRADOS"
        styleGroup="d-flex align-items-center modal-general"
        styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
        show={showAbonos}
        handleClose={() => {
          setShowAbonos(false);
          setDescripcionAbonoExpandida(null);
        }}
      >
        {abonos.length === 0 ? (
          <ParrafoComponent styleGroup="text-center color-gris fw400 WorkSans">
            Aún no hay abonos registrados
          </ParrafoComponent>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered tableGeneral">
              <thead>
                <tr>
                  <th className={`color-madera text-end ${stylegeneral.celdaAjustada}`}>Monto</th>
                  <th className="color-madera">Descripción</th>
                  <th className={`color-madera text-center ${stylegeneral.celdaAjustada}`}>Fecha</th>
                  <th className={`color-madera ${stylegeneral.celdaAjustada}`}>Registrado por</th>
                  <th className={`color-madera text-center ${stylegeneral.celdaAjustada}`}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {abonos.map((abono) => {
                  const expandida = descripcionAbonoExpandida === abono.id;
                  return (
                    <tr key={abono.id}>
                      <td className={`text-end ${stylegeneral.celdaAjustada}`}>
                        {formatPrice(abono.monto)}
                      </td>
                      <td
                        className={`${stylegeneral.celdaTruncada} ${expandida ? stylegeneral.expandida : ""}`}
                        title={abono.descripcion || ""}
                        onClick={() =>
                          setDescripcionAbonoExpandida(expandida ? null : abono.id)
                        }
                      >
                        {abono.descripcion || "-"}
                      </td>
                      <td className={`text-center ${stylegeneral.celdaAjustada}`}>
                        {abono.fecha_abono ? formatDate(abono.fecha_abono) : "-"}
                        {abono.hora_abono ? ` ${abono.hora_abono.slice(0, 5)}` : ""}
                      </td>
                      <td className={stylegeneral.celdaAjustada}>{abono.Usuario?.nombre || "-"}</td>
                      <td className={`text-center ${stylegeneral.celdaAjustada}`}>
                        <div className="d-flex align-items-center justify-content-center gap-2">
                          <button
                            type="button"
                            className={`${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex`}
                            title="Editar abono"
                            onClick={() => handleShowEditarAbono(abono)}
                          >
                            <Icon icon="raphael:edit" />
                          </button>
                          <button
                            type="button"
                            className={`${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex color-danger`}
                            title="Eliminar abono"
                            onClick={() => handleShowEliminarAbono(abono)}
                          >
                            <Icon icon="majesticons:delete-bin" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </ModalGeneralComponent>

      <ModalGeneralComponent
        ModalHeader
        titulo="EDITAR ABONO"
        styleGroup="d-flex align-items-center modal-general"
        styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
        show={showEditarAbono}
        handleClose={handleCloseEditarAbono}
      >
        <form onSubmit={confirmarEditarAbono}>
          <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">
            {mensajeEditarAbono}
          </ParrafoComponent>

          <div className="row mb-3 gap-3 gap-md-0">
            <div className="col-12 col-md-4">
              <MoneyInputComponent
                label="Monto del abono"
                styleLabel="fw600 WorkSans"
                name="monto"
                value={formEditarAbono.monto}
                onChange={handleChangeEditarAbono}
              />
            </div>
            <div className="col-12 col-md-4">
              <InputComponent
                label="Fecha"
                styleLabel="fw600 WorkSans"
                type="date"
                name="fecha_abono"
                value={formEditarAbono.fecha_abono}
                onChange={handleChangeEditarAbono}
              />
            </div>
            <div className="col-12 col-md-4">
              <InputComponent
                label="Hora"
                styleLabel="fw600 WorkSans"
                type="time"
                name="hora_abono"
                value={formEditarAbono.hora_abono}
                onChange={handleChangeEditarAbono}
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-12">
              <textarea
                name="descripcion"
                placeholder="Descripción del abono"
                className="form-control"
                rows={3}
                value={formEditarAbono.descripcion}
                onChange={handleChangeEditarAbono}
              ></textarea>
            </div>
          </div>

          <div className="d-flex w-100 justify-content-end">
            <button
              type="button"
              className={`${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3`}
              onClick={handleCloseEditarAbono}
            >
              CANCELAR
            </button>
            <button type="submit" className={`btn ${stylebtn.btn} ${stylebtn.primary}`}>
              GUARDAR
            </button>
          </div>
        </form>
      </ModalGeneralComponent>

      <ModalGeneralComponent
        styleGroup="d-flex align-items-center modal-general"
        styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
        show={showEliminarAbono}
        handleClose={handleCloseEliminarAbono}
      >
        <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-2 text-center">
          ¿Seguro que quiere eliminar este abono?
        </TitleH2Component>
        <ParrafoComponent styleGroup="box-text color-gris fw400 WorkSans mb-4 text-center">
          Esto descuenta el monto de lo abonado en este alquiler.
        </ParrafoComponent>
        <div className="d-flex justify-content-end">
          <button
            type="button"
            onClick={handleCloseEliminarAbono}
            className={`btn ${stylebtn.btn} ${stylebtn.danger}`}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
            onClick={confirmarEliminarAbono}
          >
            SI
          </button>
        </div>
      </ModalGeneralComponent>
    </Fragment>
  );
};

export default DetalleAlquilerPage;
